<template>
  <div class="page">
    <van-empty image="network" description="您要查看的页面不存在">
      <van-button type="primary" plain @click="$router.push('/')"
        >返回首页</van-button
      >
    </van-empty>
  </div>
</template>
